controllers.controller('ViewQuestionnaireController', [
    '$scope', '$state', '$timeout', '$location', '$ionicScrollDelegate', 'ionicToast', '$ionicLoading', '$ionicPopup',
    'LocaleService', 'API', 'AccountService', 'Storage', 'Utils', 'UserService', 'constants', 'QuestionModel', 'ErrorService', 'LoginService', 'UserControl',
    function ($scope, $state, $timeout, $location, $ionicScrollDelegate, ionicToast, $ionicLoading, $ionicPopup,
              LocaleService, API, AccountService, Storage, Utils, UserService, Const, QuestionModel, ErrorService, LoginService, UserControl) {

        // LocaleService.wait().then(function (translation) {
        //     $scope.translation = translation;
        // });
        $scope.translation = LocaleService.translation;

        if (Const['viewQuestionnaireEnable'] && Storage.get('regulated')) {
            var user = UserService.get();
            if (user.registrationState === Const.userState.questionnaire && user.classification === "" && user.liveAccountExists) {
                return $state.go('questionnaireMessage');
            }
        }

        $scope.permit = {
            checked: false
        };
        $scope.formTemplate = [];
        $scope.formData = {};

        $scope.questionGroups = Object.assign([], Const.questionGroups);
        $scope.currentQuestionGroup = "";
        $scope.currentQuestionnaireGroup = [];
        $scope.control = {};

        $scope.scoringRules = Const['scoringRules'] || [];
        $scope.scoringRule = null;

        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false,
            isProcess: false
        };

        $scope.user = UserService.get();

        $scope.navigate = function (state, params) {
            log('navigate to ', state);
            return $state.go(state, params);
        };

        $scope.showQuestionnair = $scope.user.registrationState === 3 && $scope.user.classification.length > 0 && $scope.user.liveAccountExists;

        $scope.modalDialogData = {};

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'ViewQuestionnaireComponent',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        function formatRawQuestion(questions, customerAnswers) {

            function format(question) {
                var customerAnswer = _.find(customerAnswers, {questionId: question.id}) || {};
                question.values = customerAnswer['answerIds'] || [];
                question.other = customerAnswer['other'] || "";
                return question;
            }

            return questions.map(format);
        }

        $scope.showQuestionnair && API.questions()
            .then(checkResponse)
            .then(function (response) {
                $scope.questionGroups = Const['questionGroups'].map(function(group){
                    return {
                        group: group,
                        questions:  formatRawQuestion(response.questions, response.customerAnswers)
                            .map(function (rawQuestion) {
                                return new QuestionModel(rawQuestion, $scope.translation)
                            }).filter(function(question) {
                                return question.group === group;
                            })
                    }
                })
            })

        $scope.$on('$ionicView.beforeEnter', function () {
            $scope.state = UserControl.getState();
            if ($scope.state) {
                return $state.go($scope.state, {cache: false});
            }

            if ($scope.user && !$scope.user.tnc && Const['tncPopup']) {
                return $state.go('tnc', {cache: false});
            }
            if ($scope.user) {
                switch ($scope.user.registrationState) {
                    case Const.userState.initial:
                        return $state.go('signupPersonalProfile', {cache: false});
                    case Const.userState.personal:
                        return $state.go('signupQuestionnaire', {cache: false});
                }
            }
        });
    }
]);
